(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .component('patrimoinePropertyImportForm', {
        templateUrl: 'partials/patrimoine/property_import_form.html',
        controller: ImportFormController,
        bindings: {
            ngModel: '='
        }
    });


    function ImportFormController(swif) {
        'ngInject';
        console.log('init ImportFormController');
        var $ctrl = this;
        //get type from the category
        this.$onInit = function () {
            loadCategory();
        };
        this.$onChanges = function () {
            loadCategory();
        };
        this.selectDataset = function (dataset) {
            //make http request to load the corresponding dataset
        };
        function loadCategory() {
            if ($ctrl.ngModel) {
                if ($ctrl.ngModel._type === 'patrimoine_equipment') {
                    swif.data.get('equipment_category', $ctrl.ngModel.categ_id[0])
                    .then(function (category) {
                        $ctrl.category = category;
                    });
                }
            }
        }

    }


})();
